{
  "pt": {
    "question": {
      "actions": {
        "addDocuments": "Adicionar documentos",
        "cancel": "Cancelar",
        "createQuestion": "Criar pergunta",
        "delete": "Eliminar",
        "deleteDocuments": "Eliminar documentos",
        "edit": "Editar",
        "moveDown": "Mover para baixo",
        "moveUp": "Mover para cima",
        "new": "Pergunta",
        "save": "Guardar"
      },
      "attributes": {
        "answer": "Resposta",
        "documents": "Documentos / Imagens",
        "name": "Questão",
        "question": "Questão"
      },
      "labels": {
        "editQuestion": "Editar pergunta",
        "newQuestion": "Nova pergunta"
      },
      "toasts": {
        "create": "Questão criada",
        "delete": "Questão eliminada",
        "update": "Pergunta actualizada"
      },
      "validation": {
        "needAnswer": "Resposta necessária",
        "needQuestion": "Pergunta necessária"
      }
    }
  }
}
